import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Survey } from '../state-man/models/survey.model';
import { LoggerService } from './logger.service';
import { UiService } from './ui.service';

@Injectable({
  providedIn: 'root'
})
export class SurveyService {

  constructor(
    private apiService: ApiService,
    private uiService: UiService
  ) { }

  public async getMine () : Promise<Survey[] | null> {   
    try {      
      const ret = await this.apiService.apiReturnsAny('get', 'survey/mine/')          
      const surveys = (ret && Array.isArray(ret)) ? Survey.buildMany(ret) : null

      if (!surveys) return null
      return surveys      
    } catch (error) {
      LoggerService.log(error + 'survey/mine')
      await this.uiService.showToast('An unexpected error occurred and has been sent to the support team.')  
      return null
    }    
  }  


  public async addSurvey(survey_entry: Survey) : Promise<Survey | null> {
    try {
      const body = survey_entry
      const obj = await this.apiService.apiReturnsAny('post', 'survey/', body, 'application/json')    
      return obj
    } catch (error) {
      LoggerService.log(error + 'post survey/')
      await this.uiService.showToast('An unexpected error occurred and has been sent to the support team.')  
      return null
    }    
  }   

  public async updateSurvey(survey_entry: Survey) : Promise<Survey | null> {
    try {          
      const body = survey_entry
      const obj = await this.apiService.apiReturnsAny('put', 'survey/' + survey_entry.id, body, 'application/json')         
      return obj      
    } catch (error) {
      LoggerService.log(error + 'put survey/')    
      await this.uiService.showToast('An unexpected error occurred and has been sent to the support team.')  
      return null
    }    
  }

  public async deleteSurvey(survey_entry: Survey) : Promise<any> {
    try {
      const ret = await this.apiService.apiReturnsAny('delete', 'survey/' + survey_entry.id)               
      return ret
    } catch (error) {
      LoggerService.log(error + 'delete survey/')    
      await this.uiService.showToast('An unexpected error occurred and has been sent to the support team.')  
      return null
    }    
  }  
}
